<div [hidden]="hidden">
  <mat-form-field [ngClass]="{'full-width': fullWidth}">
    <mat-select #select ngDefaultControl [id]="name" [class]="selectClass" [multiple]="multiple"
      [placeholder]="required ? label + ' *' : label " [formControl]="formControlSelect ? formControlSelect : null"
      [panelClass]="['ivselect', name, search ? 'with-search': '']" (selectionChange)="change($event)"
      (openedChange)="openedChange($event)">
      <mat-form-field class="full-width select-search" *ngIf="search" [appearance]="mode">
        <input #searchInput="matInput" matInput [(ngModel)]="query" (input)="filter();" name="select-search"
          (keydown)="preventSpace($event)" *ngIf="search" autocomplete="off" [disabled]="inputDisabled">
        <i class="material-icons" matSuffix>search</i>
      </mat-form-field>
      <div *ngFor="let option of options; let i = index" class="option" (click)="optionClick(i)">
        <mat-option [value]="option.value" (onSelectionChange)="onOptionSelected($event)"
          [disabled]="disabled ? disabled : !select?.options?._results[i]?._selected" [attr.data-index]="i"
          [attr.data-level]="option.level" [attr.data-parent]="option.parent"
          [ngClass]="{'parent-option': option.isParent, 'child-option': option.parent, 'has-icon': true }">
          {{option.label}}
        </mat-option>
        <button mat-icon-button class="btn" [matMenuTriggerFor]="appMenu"
          [disabled]="option.disabledMenu || false">
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
      <mat-menu #appMenu="matMenu">
        <ng-template matMenuContent>
          <mat-radio-group class="example-radio-group" [disabled]="disabledRadioGroup"
            [formControl]="formGroupRadio.get('radio')" (change)="radioChange($event)">
            <mat-radio-button class="example-radio-button" *ngFor="let item of submenu; let j = index"
              [value]="item.value">
              {{item.label}}
            </mat-radio-button>
          </mat-radio-group>
        </ng-template>
      </mat-menu>
    </mat-select>
    <mat-error *ngIf="getErrorMessage()?.length">
      {{getErrorMessage()[0]}}
    </mat-error>
  </mat-form-field>
</div>
